module.exports = __webpack_public_path__ + "static/media/calendar.d5d8c269.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/calendar.svg
// module id = 1547
// module chunks = 0